module.exports = __webpack_public_path__ + "p8_img1.jpg?95db4d4ae656e722c808fdc1039ebfcb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p8/p8_img1.jpg
// module id = 120
// module chunks = 0